// extracted by mini-css-extract-plugin
export default {"container":"hLjIaLQzmE7ZzwbvtmvS","timeContainer":"MttvLzk_Pu6RX2u05QgG","time":"QvaXySDfhgruwLpnuat7","divider":"j9WbAUpKMNIsriGND1Aq","description":"PmegcCrcEQF6tisdYMFz"};